module.exports = require("assert");


//////////////////
// WEBPACK FOOTER
// external "assert"
// module id = 186
// module chunks = 0